import { useState } from 'react';

export const useRDPModalModals = () => {
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isEditRecipeModalOpen, setIsEditRecipeModalOpen] = useState(false);
  const [isUpdateCartModalOpen, setIsUpdateCartModalOpen] = useState(false);
  const [isServingSizeWarningModalOpen, setIsServingSizeWarningModalOpen] =
    useState(false);

  return {
    isEditOpen,
    setIsEditOpen,
    isEditRecipeModalOpen,
    setIsEditRecipeModalOpen,
    isUpdateCartModalOpen,
    setIsUpdateCartModalOpen,
    isServingSizeWarningModalOpen,
    setIsServingSizeWarningModalOpen,
  };
};

export type RDPModalModals = ReturnType<typeof useRDPModalModals>;
